import { MODEL_VERSION } from '@/app/constants';
import type { FormTabType, ModelVersion } from '@/app/types';
import { isExtendTask } from './task-types';

const MODEL_VERSION_KEY_MAP: Partial<Record<ModelVersion, string>> = {
  // 其他待补充
  [MODEL_VERSION.Q2]: 'q2',
  [MODEL_VERSION.Q2_PRO]: 'q2pro',
  [MODEL_VERSION.Q3]: 'q3',
  [MODEL_VERSION.Q4]: 'q4',
};

/**
 * 生成 from_page 参数，用于埋点上报
 * @param options 参数
 * @param options.modelVersion 模型版本
 * @param options.type 表单类型
 * @param options.key 设置项
 * @returns from_page 参数
 */
export const generateFromPage = (options: {
  modelVersion: ModelVersion;
  type: Exclude<FormTabType, 'scene'> | 'video2extend' | 'video2extail';
  key: string | null;
  value?: string;
}) => {
  if (isExtendTask(options.type)) {
    return 'extend_upgrade';
  }
  if (!MODEL_VERSION_KEY_MAP[options.modelVersion] || options.type === 'reference2image') {
    return `settings ${options.key}`;
  }
  if (options.key === 'transition') {
    return `${MODEL_VERSION_KEY_MAP[options.modelVersion]}_${options.type}_cinematic`;
  }
  return `${MODEL_VERSION_KEY_MAP[options.modelVersion]}_${options.type}_${options.key}`;
};
